/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../../pipes/pipes.module';
import {InputAndCodeFilterComponent} from './input-and-code-filter.component';
import {TooltipModule} from '../../tooltip/tooltip.module';
import {FilterFooterModule} from '../filter-footer/filter-footer.module';
import {InputModule} from '../../input/input.module';
import {LoadingSpinnerModule} from '../../loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [InputAndCodeFilterComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        TooltipModule,
        FilterFooterModule,
        InputModule,
        LoadingSpinnerModule
    ],
    exports: [InputAndCodeFilterComponent]
})
export class InputAndCodeFilterModule {

}
